import EnhancedTextField from "../../../EnhancedTextField";
import moment from "moment";
import EnhancedSelect from "../../../EnhancedSelect";
import {StyledFilterControl, StyledFilterSelector} from "../../catalog_filters";
import React from "react";
import {withTheme, Typography} from "@material-ui/core";

function FilterField(props) {
    const {theme} = props;
    const {type, value, onValueChange, operator} = props;
    const {options, loadingOptions} = props;
    
    const [value2, setValue2] = React.useState(
        Array.isArray(value) && value.length > 1 ? value[1] : ''
    );

    if (loadingOptions || options) {
        return (
            <EnhancedSelect
                placeholder={"Value"}
                value={
                    value === "" ? [] : 
                    Array.isArray(value) ? value.map(v => 
                        typeof v === 'object' ? v : {value: v, label: v}
                    ) : [{value: value, label: value}]
                }
                options={options == null ? [] : options.map((option) => {
                    return {
                        value: option.label,
                        label: option.label
                    }
                })}
                onChange={(e) => {
                    // Handle multi-select
                    if (Array.isArray(e)) {
                        // Extract just the values from the selected options
                        const values = e.map(item => item.value);
                        onValueChange({value: values});
                    } else if (e) {
                        onValueChange({value: e.value});
                    } else {
                        onValueChange({value: []});
                    }
                }}
                isMulti={true}
                containerStyle={{flex: 0.6, minWidth: "200px"}}
                selectorStyle={StyledFilterSelector}
                controlStyle={StyledFilterControl}
                placeholderStyle={{color: theme.palette.textPrimary.main}}
                dropdownIndicatorStyle={{color: theme.palette.textPrimary.main}}/>
        )
    } else if (type === "bool") {
        return (
            <EnhancedSelect
                placeholder={"Value"}
                value={(value === "") ? "" : {value: value, label: `${value}`}}
                options={[
                    {value: true, label: "true"},
                    {value: false, label: "false"}
                ]}
                onChange={(e) => {
                    onValueChange(e)
                }}
                containerStyle={{flex: 0.6, minWidth: "200px"}}
                selectorStyle={StyledFilterSelector}
                controlStyle={StyledFilterControl}
                placeholderStyle={{color: theme.palette.textPrimary.main}}
                dropdownIndicatorStyle={{color: theme.palette.textPrimary.main}}/>

        )
    } else if (operator === 'datebt' && (type === "date" || type === "localdate")) {
        // Date range for between operator
        return (
            <div style={{display: 'flex', gap: '8px', flex: 0.6, minWidth: '200px'}}>
                <EnhancedTextField
                    type="date"
                    placeholder="Start"
                    InputProps={{
                        inputProps: {
                            max: Array.isArray(value) && value[1]
                                ? moment(value[1]).format("YYYY-MM-DD")
                                : value2
                                    ? moment(value2).format("YYYY-MM-DD")
                                    : ""
                        }
                    }}
                    value={
                        Array.isArray(value) && value[0]
                            ? moment(value[0]).format("YYYY-MM-DD")
                            : value && !Array.isArray(value)
                                ? moment(value).format("YYYY-MM-DD")
                                : ""
                    }
                    onChange={(e) => {
                        const startDate = moment(e.target.value, "YYYY-MM-DD").toISOString(false);
                        const endDate = value2 || (Array.isArray(value) && value[1]) || '';
                        
                        onValueChange({value: [startDate, endDate]});
                    }}
                    style={{flex: 1}}
                />
                <Typography variant="body2" style={{alignSelf: 'center', margin: '0 4px'}}>-</Typography>
                <EnhancedTextField
                    type="date"
                    placeholder="End"
                    InputProps={{
                        inputProps: {
                            min: Array.isArray(value) && value[0]
                                ? moment(value[0]).format("YYYY-MM-DD")
                                : ""
                        }
                    }}
                    value={
                        Array.isArray(value) && value[1]
                            ? moment(value[1]).format("YYYY-MM-DD")
                            : value2
                                ? moment(value2).format("YYYY-MM-DD")
                                : ""
                    }
                    onChange={(e) => {
                        const endDate = moment(e.target.value, "YYYY-MM-DD").toISOString(false);
                        const startDate = Array.isArray(value) && value[0] ? value[0] : '';
                        
                        setValue2(endDate);
                        onValueChange({value: [startDate, endDate]});
                    }}
                    style={{flex: 1}}
                />
            </div>
        )
    } else {
        return (
            // This date checking logic is needed because if the operator lt or gt is selected then the time needs to be an ISO string or else
            // Azure search gives errors
            <div style={{flex: 0.6, minWidth: "200px"}}>
                <EnhancedTextField
                    type={
                        (type === "date" || type === "localdate")
                            ? "date"
                            : type === "number" ? "number" : "text"
                    }
                    value={
                        type === "date" || type === "localdate"
                            ? value === ""
                                ? ""
                                : moment(value).format("YYYY-MM-DD")
                            : value
                    }
                    onChange={(e) => {
                        if (type === "date" || type === "localdate")
                            onValueChange({value: moment(e.target.value, "YYYY-MM-DD").toISOString(false)});
                        else if (type === "number")
                            onValueChange({value: Number(e.target.value)});
                        else
                            onValueChange(e.target);
                    }}/>
            </div>
        )
    }
}

export default withTheme(FilterField);
